import type { LucideIcon } from "lucide-react";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { LAUNCH_PAD_UNAVAILABLE_HINT } from "@/components/launch_pad/launchPadConfig";
import { LaunchPadUnavailableHint } from "@/components/launch_pad/LaunchPadUnavailableHint";
import { cn } from "@/lib/utils";

type LaunchPadInsightUpsellCardProps = {
  title: string;
  description: string;
  icon: LucideIcon;
  testId?: string;
};

export function LaunchPadInsightUpsellCard({
  title,
  description,
  icon: Icon,
  testId,
}: LaunchPadInsightUpsellCardProps) {
  return (
    <Card
      className={cn(
        "group relative overflow-hidden border-dashed bg-muted/20 opacity-75 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      )}
      data-testid={testId}
      tabIndex={0}
      role="group"
      aria-disabled
      aria-label={`${title}. ${LAUNCH_PAD_UNAVAILABLE_HINT}`}
    >
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-sm font-semibold text-muted-foreground">
          <Icon className="h-4 w-4" aria-hidden />
          {title}
        </CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <LaunchPadUnavailableHint />
    </Card>
  );
}
